var block_testimonials = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();

        this.initSlider();
	},

	bindUI: function() {
		this.ui.$slider = $('.js-testimonials-slider');
		this.ui.$sliderRevert = $('.js-testimonials-slider-revert');
	},

	bindEvents: function() {
		// this.ui.$slick.on('ready', this.mediaToCarousel.bind(this));
	},

	initSlider: function() {
		this.ui.$slider.slick({
			responsive: [
				{
					breakpoint : 500,
					settings : {
						dots: true,
						prevArrow: false,
						nextArrow: false
					}
				},
				// {
				// 	breakpoint : 820,
				// 	settings : {
				// 		dots: true,
				// 		prevArrow: false,
				// 		nextArrow: false
				// 	}
				// }
			],
			centerMode: false,
            dots: false,
            slidesToShow: 1,
            slideToScroll: 1,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="slick-prev" style="display:none;"></button>',
			nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-caret" aria-hidden="true"><use xlink:href="#icon-caret" /></svg>   </button>'
		});

		this.ui.$sliderRevert.slick({
			responsive: [
				{
					breakpoint : 500,
					settings : {
						dots: true,
						prevArrow: false,
						nextArrow: false
					}
				},
				// {
				// 	breakpoint : 820,
				// 	settings : {
				// 		dots: true,
				// 		prevArrow: false,
				// 		nextArrow: false
				// 	}
				// }
			],
			centerMode: false,
            dots: false,
            slidesToShow: 1,
            slideToScroll: 1,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-caret" aria-hidden="true"><use xlink:href="#icon-caret" /></svg>   </button>',
			nextArrow: '<button type="button" class="slick-next"style="display:none;></button>'
		});

		
	},

};

module.exports = block_testimonials;